import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IShippableOffer } from '@/shared/model/shippable-offer.model';

const baseApiUrl = 'api/shippable-offers';
const baseSearchApiUrl = 'api/_search/shippable-offers?query=';

export default class ShippableOfferService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IShippableOffer> {
    return new Promise<IShippableOffer>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IShippableOffer): Promise<IShippableOffer> {
    return new Promise<IShippableOffer>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IShippableOffer): Promise<IShippableOffer> {
    return new Promise<IShippableOffer>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
